import { render, staticRenderFns } from "./TasksMainCalendar.vue?vue&type=template&id=cbfebf14&scoped=true&"
import script from "./TasksMainCalendar.vue?vue&type=script&lang=js&"
export * from "./TasksMainCalendar.vue?vue&type=script&lang=js&"
import style0 from "./TasksMainCalendar.vue?vue&type=style&index=0&id=cbfebf14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbfebf14",
  null
  
)

export default component.exports